import Phaser from "phaser";
import { GameConfig } from "./config/game";
import { Preload, Game } from "./scene";
import { Global } from "./utils/global";
import { Scenes } from "./utils/scenes";

declare global {
    interface Window {
        phaserGame: Phaser.Game;
        showOrHideOrientationPopup: (show: boolean) => void; //Splash
        showOrHideIntro: (show: boolean) => void; //Splash
        enablePlay: (show: boolean) => void;
        showOrHideLevelUpPopup: (show: boolean) => void;
        showOrHideInstructionPopup1: (show: boolean) => void;
        showOrHideInstructionPopup2: (show: boolean) => void;
        showOrHideInstructionPopup3: (show: boolean) => void;
        showOrHideInstructionPopup4: (show: boolean) => void;
        showOrHideInstructionPopup5: (show: boolean) => void;
        showOrHideLeaderboardPopup: (show: boolean) => void;
        showOrHideRegisterPopup: (show: boolean, isGameCompleted?: boolean) => void; //End
        isRegisterOpen: () => boolean;
        startGame: () => void; //Start game;
        resumeGame: () => void;
        pauseGame: () => void;
        restartGame: () => void;
        updateLevel:() => void;
        getLevel:() => void;
        resetLevel: () => void;
        pointsEarned: number;
    }
    interface Element {
        mozRequestFullScreen?(): void;
        msRequestFullscreen?(): void;
        webkitRequestFullscreen?(): void;
        webkitEnterFullscreen?(): void;
    }
    interface Document {
        fullscreenElement: any;
        webkitExitFullscreen: any;
        mozFullScreenElement: any;
        webkitFullscreenElement: any;
        msFullscreenElement?: any;
    }
}

type scaleMode = 'FIT' | 'SMOOTH'
const DEFAULT_WIDTH = 1024;
const DEFAULT_HEIGHT = 576
const MAX_WIDTH = 1920
const MAX_HEIGHT = 1080
const SCALE_MODE: scaleMode = 'FIT' // FIT OR SMOOTH

export const configureGame = (parent: HTMLDivElement): Phaser.Game => {

    //Game configuration
    const config: Phaser.Types.Core.GameConfig = {
        parent: parent,
        ...GameConfig,
        scene:[
            Preload,
            Game
        ]
    };

    //Game instance
    window.phaserGame = new Phaser.Game(config);
    window.enablePlay(false);
    
    return window.phaserGame;
};


//Listener function
const orientation = () => {

    if(window.phaserGame.device.os.desktop){
        //
    }else{
        if(window.innerHeight > window.innerWidth && window.outerHeight > 400) {
            //window.phaserGame.canvas.style.visibility = 'hidden';
        } else {
            //window.phaserGame.canvas.style.visibility = 'visible';
        }
    }

}

const gameresize = () => {

    const w = window.innerWidth
    const h = window.innerHeight

    const width = DEFAULT_WIDTH
    const height = DEFAULT_HEIGHT
    const maxWidth = MAX_WIDTH
    const maxHeight = MAX_HEIGHT

    const scale = Math.min(w / width, h / height)
    const newWidth = Math.min(w / scale, maxWidth)
    const newHeight = Math.min(h / scale, maxHeight)

    // smooth scaling
    let smooth = 1.5; //Android
    if(window.phaserGame.device.os.desktop){
        smooth = 1.6;
    }else if(window.phaserGame.device.os.iPhone){
        smooth = 1.35
    }else if(window.phaserGame.device.os.iPad){
        smooth = 1.4
    }

    //Update size
    Global.SCREEN_W = (newWidth * smooth);
    Global.SCREEN_H = (newHeight * smooth);

    Global.SCREEN_CX = Global.SCREEN_W * 0.5;
    Global.SCREEN_CY = Global.SCREEN_H * 0.5;

    // resize the game
    window.phaserGame.scale.resize((newWidth * smooth), (newHeight * smooth));

    // scale the width and height of the css
    window.phaserGame.canvas.style.width = newWidth * scale + 'px';
    window.phaserGame.canvas.style.height = newHeight * scale + 'px';

    // center the game with css margin
    window.phaserGame.canvas.style.paddingTop = Math.round( (h - newHeight * scale) / 2 ) + 'px';
    window.phaserGame.canvas.style.paddingLeft = Math.round( (w - newWidth * scale) / 2 ) + 'px';

}

//On load event
window.onload = function(){

    //Resize
    if(window.phaserGame.device.os.iOS){
        Global.ResizeDelay = 100;
    }
    window.addEventListener('resize', () => {
        setTimeout(()=>{
            gameresize();
        },Global.ResizeDelay);
    });
    setTimeout(()=>{
        gameresize();
    },Global.ResizeDelay);

    //Orientation
    window.addEventListener('orientationchange', () => {
        setTimeout(()=>{
            orientation();
        },Global.OrientationDelay);
    });
    orientation();

    //Fullscreen
    document.addEventListener("fullscreenchange", () => {
        if(document.fullscreenElement){
            //Fullscreen On
        }else{
            //Fullscreen Off
            showfullscreenalert();
        }
    });

    document.addEventListener("mozfullscreenchange", () => {
        if(document.mozFullScreenElement){
            //Fullscreen On
        }else{
            //Fullscreen Off
            showfullscreenalert();
        }
    });

    document.addEventListener("webkitfullscreenchange", () => {
        if(document.webkitFullscreenElement){
            //Fullscreen On
        }else{
            //Fullscreen Off
            showfullscreenalert();
        }
    });

    document.addEventListener("msfullscreenchange", () => {
        if(document.msFullscreenElement){
            //Fullscreen On
        }else{
            //Fullscreen Off
            showfullscreenalert();
        }
    });

}

const showfullscreenalert = function(){
    //@typescript-eslint/no-empty-function
}


//Start game
window.startGame = function(){
    window.phaserGame.scene.stop(Scenes.Preload);
    window.phaserGame.scene.start(Scenes.Game);
}

window.pauseGame = function(){
    if(window.phaserGame.scene.isActive(Scenes.Game)
        && window.phaserGame.scene.isVisible(Scenes.Game)){
        window.phaserGame.scene.pause(Scenes.Game);
    }
}

window.resumeGame = function(){
    if(window.phaserGame.scene.isPaused(Scenes.Game)){
        window.phaserGame.scene.resume(Scenes.Game);
    }
}

window.restartGame = function(){
    window.phaserGame.scene.stop(Scenes.Game);
    window.phaserGame.scene.start(Scenes.Game);
}

window.updateLevel = function(){
    Global.LEVEL += 1;
    if(Global.LEVEL > 5){
        Global.LEVEL = 5;
    }
}

window.getLevel = function(){
    return Global.LEVEL
}

window.resetLevel = function(){
    Global.LEVEL = 1;
}